import { render, staticRenderFns } from "./ListDropdownButtons.vue?vue&type=template&id=83fa0f5a&scoped=true&"
import script from "./ListDropdownButtons.vue?vue&type=script&lang=js&"
export * from "./ListDropdownButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fa0f5a",
  null
  
)

export default component.exports